// extracted by mini-css-extract-plugin
export default {"etc":"ShowMore_etc__jQ8Rc","button":"ShowMore_button__6d1FQ"};